module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-ircinput"
  }, [_c('div', {
    ref: "editor",
    staticClass: "kiwi-ircinput-editor",
    attrs: {
      "contenteditable": "true",
      "role": "textbox",
      "placeholder": _vm.placeholder
    },
    on: {
      "keypress": function($event) {
        _vm.updateValueProps();
        _vm.$emit('keypress', $event)
      },
      "keydown": function($event) {
        _vm.updateValueProps();
        _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        _vm.updateValueProps();
        _vm.$emit('keyup', $event)
      },
      "textInput": function($event) {
        _vm.updateValueProps();
        _vm.onTextInput($event);
        _vm.$emit('textInput', $event)
      },
      "mouseup": function($event) {
        _vm.updateValueProps();
      },
      "click": function($event) {
        _vm.$emit('click', $event)
      },
      "paste": _vm.onPaste
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-275a2d8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/IrcInput.vue
// module id = 483
// module chunks = 2